import { useQuery } from "react-query";
import { fetchAdoTeams, AdoTeam } from "../api/aiMetricsApi";

const EXCLUDED_TEAMS = new Set(
  ["NH360 Product Documentation", "Reporting", "Resporting", "Support"].map(
    (name) => name.trim().toLowerCase(),
  ),
);

const isExcludedTeam = (team: AdoTeam): boolean =>
  EXCLUDED_TEAMS.has((team.team_name ?? "").trim().toLowerCase());

export const useAdoTeams = () => {
  return useQuery<AdoTeam[], Error>({
    queryKey: ["adoTeams"],
    queryFn: fetchAdoTeams,
    staleTime: 5 * 60 * 1000,
    select: (teams) => teams.filter((team) => !isExcludedTeam(team)),
  });
};
